'use strict';

module.exports = require('array-includes');
